import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../data.service';
import { BillingOrderControlView } from 'src/app/model/billing/billing-order-control-view';
import { BillingOrderControlEdit } from 'src/app/model/billing/billing-order-control-edit';
import { BillingOrderControl } from 'src/app/model/billing/billing-order-control';
import { BillingStateFilter } from '../../model/billing/billing-state-filter';
import { BillingCloseService } from './billing-close.service';
import { NoBillingReasonFilter } from '../../model/billing/no-billing-reason-filter';
import { LogView } from '../../model/log-view';
import { BillingMedicalAppointmentProcedureLog } from '../../model/billing/billing-medical-appointment-procedure-log';

@Injectable({
  providedIn: 'root'
})
export class BillingOrderControlService {

  constructor( private billingCloseService: BillingCloseService,
               private dataService: DataService) {
  }

  private readonly getBillingOrderControlViewEndPoint: string = '/billingOrderControl/getBillingOrderControlView/';
  private readonly getBillingOrderControlEndPoint: string = '/billingOrderControl/getBillingOrderControl/';
  private readonly billingOrderControlSaveEndPoint: string = '/billingOrderControl/billingOrderControlSave/';
  private readonly getBillingStateFilterEndPoint: string = '/billingOrderControl/getBillingStateFilter/';
  private readonly getNoBillingReasonFilterEndPoint: string = '/billingOrderControl/getNoBillingReasonFilter/';
  private readonly getValidationLogViewEndPoint: string = '/billingOrderControl/getValidationLogView/';
  private readonly getBillingMedicalAppointmentProcedureLogsEndPoint: string = '/billingOrderControl/getBillingMedicalAppointmentProcedureLogs/';

  async rollBackOrderControlState(medicalAppointmentProcedureIds: number[]): Promise<boolean> {
    return this.billingCloseService.billingOrderControlStateRollBack(medicalAppointmentProcedureIds);
  }

  async billingOrderControlSave(billingOrderControlEdit: BillingOrderControlEdit): Promise<boolean> {
    return await this.dataService
                     .post<boolean>(this.billingOrderControlSaveEndPoint, billingOrderControlEdit)
                     .toPromise();
  }

  async getBillingStateFilter(): Promise<BillingStateFilter[]> {
    return await this.dataService
                     .get<BillingStateFilter[]>(this.getBillingStateFilterEndPoint, {})
                     .toPromise();
  }

  async getBillingOrderControlView(protocol: string): Promise<BillingOrderControlView> {
    const params = { protocol: protocol };
    return await this.dataService
                     .get<BillingOrderControlView>(this.getBillingOrderControlViewEndPoint, params)
                     .toPromise();
  }

  async getBillingOrderControl(medicalAppointmentId: number): Promise<BillingOrderControl>  {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
                     .get<BillingOrderControl>(this.getBillingOrderControlEndPoint, params)
                     .toPromise();
  }

  async getNoBillingReasonFilter(): Promise<NoBillingReasonFilter[]>  {
    const params = { };
    return await this.dataService
                     .get<NoBillingReasonFilter[]>(this.getNoBillingReasonFilterEndPoint, params)
                     .toPromise();
  }

  async getValidationLogView( medicalAppointmentId: number ): Promise<LogView[]>  {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
                     .get<LogView[]>(this.getValidationLogViewEndPoint, params)
                     .toPromise();
  }

  async getBillingMedicalAppointmentProcedureLogs( medicalAppointmentProcedureId: number ): Promise<BillingMedicalAppointmentProcedureLog[]>  {
    const params = { medicalAppointmentProcedureId: medicalAppointmentProcedureId };
    return await this.dataService
                     .get<BillingMedicalAppointmentProcedureLog[]>(this.getBillingMedicalAppointmentProcedureLogsEndPoint, params)
                     .toPromise();
  }

}
